<template>
  <BaseDialog centered contentClass="delete-emitter" ref="dialog" persistent show-actions>
    <template slot="title">{{ $t('page.business-intelligence.emitter.delete-dialog.title') }}</template>
    <template slot="content">
      <span v-if="emitter">{{
        $t('page.business-intelligence.emitter.delete-dialog.description', { name: emitter.name })
      }}</span>
      <div class="delete-emitter__actions">
        <BaseButton is-outlined class="delete-emitter__cancel" @click.native="cancelClick">{{
          $t('actions.cancel')
        }}</BaseButton>
        <BaseButton :disabled="pending" @click.native="execute">
          <span>{{ $t('actions.delete') }}</span>
        </BaseButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseDialog from '@/components/base/BaseDialog';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DeleteEmitterDialog',
  components: {
    BaseButton,
    BaseDialog,
  },
  data() {
    return { emitter: null };
  },
  computed: {
    ...mapGetters('biDashboard', ['pending']),
  },
  methods: {
    ...mapActions('biDashboard', ['deleteEmitter']),

    open(emitter) {
      this.emitter = emitter;
      this.$refs.dialog.openModal();
    },
    close() {
      this.emitter = null;
      this.$refs.dialog.isModalOpen = false;
    },
    execute() {
      const emitter = this.emitter;
      this.deleteEmitter(emitter.id)
        .then(() => {
          this.$toast.success(this.$t('page.business-intelligence.emitter.delete-dialog.delete-success'));
          this.$emit('action-succeeded', emitter);
        })
        .catch((error) => this.$toast.error(error));
      this.close();
    },
    cancelClick() {
      this.close();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__delete-emitter {
  min-height: 150px;
  max-height: 650px !important;
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }
  .close-icon__container {
    display: none;
  }
}

.delete-emitter {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }
}
</style>
